import React, { useState } from "react";
import signIn from "../../actions/signIn";
import Loader from "../Loader";
import Field from "./Field";

const SignIn = ({ setSignIn, goToSignUp }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [result, setResult] = useState({});
  const [loading, setLoading] = useState(false);

  const setSignInResult = (result) => {
    setLoading(false);
    setResult(result);
    setSignIn(result.status === "success");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    signIn(
      email,
      password,
      setSignInResult
    );
  };

  return (
    <>
      <form className="login__form" onSubmit={handleSubmit}>
        <Field
          label="Email"
          value={email}
          type="email"
          onChange={(e) => setEmail(e.target.value)}
          placeholder="designer@example.com"
        />
        <Field
          label="Password"
          value={password}
          type="password"
          onChange={(e) => setPassword(e.target.value)}
          placeholder="password"
        />
        {result.error &&
          <div className="login__error">{result.error}</div>
        }
        {loading ? (
          <Loader />
        ) : (
          <button className="login__btn">
            Log in
          </button>
        )}
      </form>
      <div className="login__hint">
        Don’t have an account? <button onClick={goToSignUp}>Sign up</button>
      </div>
    </>
  )
}

export default SignIn;